import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { ShopifyAppPricingState } from './shopify-app-pricing.reducer';

const shopifyAppPricingState = (state: RootState): ShopifyAppPricingState => state.shopifyAppPricing;

export const selectShopifyAppPlans = createSelector(shopifyAppPricingState, (state) => state.data);

export const selectShopifyAppPlansFetching = createSelector(shopifyAppPricingState, (state) => state.fetching);

export const selectShopifyAppPlansError = createSelector(shopifyAppPricingState, (state) => state.error);

export const selectShopifyAppHandle = createSelector(shopifyAppPricingState, (state) => state.appHandle);

export const selectShopifyCurrentSubscription = createSelector(
    shopifyAppPricingState,
    (state) => state.currentSubscription
);

export const selectShopifyAllSubscriptions = createSelector(shopifyAppPricingState, (state) => state.allSubscriptions);

export const selectShopifySubscriptionFetching = createSelector(
    shopifyAppPricingState,
    (state) => state.subscriptionFetching
);

export const selectShopifyAppPricingLoading = createSelector(
    shopifyAppPricingState,
    (state) => state.fetching || state.subscriptionFetching
);
